var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabTestWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.74,
    height: 19.251,
    viewBox: "0 0 21.74 19.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "labTest-white",
    transform: "translate(-984.527 -513.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M1001.115,524.382c0-3.068-5.569-10.687-5.569-10.687s-5.568,7.619-5.568,10.687a5.568,5.568,0,1,0,11.137,0Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1306",
    "data-name": "Line 1306",
    x2: 5.002,
    transform: "translate(984.927 529.384)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1307",
    "data-name": "Line 1307",
    x2: 17.255,
    transform: "translate(987.31 531.868)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1308",
    "data-name": "Line 1308",
    x2: 3.168,
    transform: "translate(999.748 516.563)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1309",
    "data-name": "Line 1309",
    x2: 7.302,
    transform: "translate(998.564 513.695)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M998.881,520.914a8.45,8.45,0,0,1-1.484,3.068,6.711,6.711,0,0,1-4.751,2.467,7.2,7.2,0,0,1-1.2-.033,4.57,4.57,0,0,0,8.67-2.017A9.213,9.213,0,0,0,998.881,520.914Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTestWhite);
export default __webpack_public_path__ + "static/media/labTest-white.43a7e65bf5034055f8799f8cd8b8a11c.svg";
export { ForwardRef as ReactComponent };